import type { QuerySort } from '#shared/types/rstore';
import type { LayoutSortingState } from '~/types/layout';
import { useProjectSchemaStore } from '~/stores/project-schema';

export function useConvertLayoutSortingStateToQuerySort() {
	const { findPrimitiveFieldById } = useProjectSchemaStore();

	function convert(layoutSortingState: LayoutSortingState | undefined): QuerySort | undefined {
		if (!layoutSortingState || layoutSortingState.length === 0) {
			return;
		}

		const querySort: QuerySort = layoutSortingState.map((sortItem) => {
			const field = findPrimitiveFieldById(sortItem.fieldId);

			if (!field) {
				return null;
			}

			return {
				[field.apiName]: { direction: sortItem.direction },
			};
		}).filter(Boolean) as QuerySort;

		return querySort.length > 0 ? querySort : undefined;
	}

	return {
		convert,
	};
}
